export const CAREPLAN_PAGES = {
  CREATE: '',
  DIAGNOSIS_A: 'primary',
  DIAGNOSIS_B: 'newPrimary',
  STAGING: 'tnmstaging',
  INTAKE: 'intake',
  TREATMENT_INFO: 'treatmentInfo',
  TEMPLATE_SELECTION: 'templateSelection',
  SITESETUP: 'linkSites',
  SIMULATION: 'simulation',
  PRESCRIPTION: 'prescription',
  MRL_SAFETY_SCREENING: 'mrlSafetyScreening',
  VOLUMING: 'voluming',
  SUBMISSION: 'submission',
  CPOT: 'cpot',
  SPECIAL_PHYSICS_CONSULT: 'specialPhysicsConsult',
};

export const CLINEX_STATUS = {
  BAILED_OUT: 'bailed_out',
};
export const NO_TEMPLATES_MESSAGE = 'No careplan template/manual site selected.';
export const VARIATION_MESSAGE = 'Variation from careplan template';
export const PEER_REVIEW_MESSAGE = 'Variation from careplan template and peer review triggered';
export const SUBMISSION_MESSAGE = 'This careplan has been submitted.';
export const DX_ONLY_SUBMISSION_MESSAGE = 'This diagnosis has been submitted.';
export const CPOT_SUBMISSION_MESSAGE =
  'This careplan has been resubmitted, please ensure that you alert the treatment team of this change.';
export const UNSUBMITTED_MESSAGE = 'You have unsubmitted changes, please resubmit.';
export const CPOT_MESSAGE = 'You are making changes to a commenced treatment. Please remember to submit.';
export const CLINEX_BETA_TESTING_MESSAGE =
  'This is a beta version of Clinex during the calibration phase. Please review the values populated';
export const CLINEX_BAILED_OUT_MESSAGE =
  'A possible bilateral case has been detected. The following fields have not been pre-populated.';
export const EXCLUDED_LATERALITIES = ['Not Applicable', 'Unpaired'];
export const SIMULATION_SUBMIT_DISABLED_MESSAGE =
  'Request simulation is available on the last sim group. Please ensure details are correct before proceeding.';
export const SIMULATION_SUBMIT_CONFIRMATION_MESSAGE =
  'Please ensure simulation details are correct for ALL sim groups before proceeding. You will be redirected back to the patient summary page after submission.';
